import React from 'react';
import './RestaurantScheduleItem.less';
import {ScheduleColumnTitle} from "elements/schedule-column-title/ScheduleColumnTitle";
import {ScheduleRowTitle} from "elements/schedule-row-title/ScheduleRowTitle";
import {ScheduleCellText} from "elements/schedule-cell-text/ScheduleCellText";

export const RestaurantScheduleItem = ({day, deliveryHours, restaurantHours, isHeader = false}) => {
	const TagName = isHeader ? 'th' : 'td';

	return (
		<tr className={'restaurant-schedule-item' + (isHeader ? ' restaurant-schedule-item--header' : '')}>
			<TagName scope={isHeader ? 'col' : false} className="restaurant-schedule-item__day">
				{
					isHeader
						? <ScheduleColumnTitle text={day}/>
						: <ScheduleRowTitle text={day}/>
				}
			</TagName>
			{deliveryHours && (
				<TagName scope={isHeader ? 'col' : false} className="restaurant-schedule-item__delivery">
					{
						isHeader
							? <ScheduleColumnTitle text={deliveryHours}/>
							: <ScheduleCellText text={deliveryHours}/>
					}
				</TagName>
			)}
			{
				restaurantHours && (
					<TagName scope={isHeader ? 'col' : false} className="restaurant-schedule-item__restaurant">
						{
							isHeader
								? <ScheduleColumnTitle text={restaurantHours}/>
								: <ScheduleCellText text={restaurantHours}/>
						}
					</TagName>
				)
			}

		</tr>
	);
}
